<form #form="ngForm" class="campanha-cliente-form" novalidate>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title">
                Clientes
            </h6>
            <p class="form-text text-muted">
                Clientes em que esta campanha é promovida e que são considerados resultado
            </p>
        </div>  
        <div class="table-responsive campanha-cliente">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th class="col-options" *ngIf="canEdit"></th>
                        <th class="col-cliente">Cliente</th>
                    </tr>
                </thead>
                <tbody *ngFor="let entity of entities; let i = index">
                    <tr>
                        <td class="col-options" *ngIf="canEdit">
                            <a (click)="delete(i)">
                                <i class="far fa-trash-alt" aria-hidden="true"></i>
                            </a>
                        </td>
                        <td class="col-cliente">
                            <sgt-typeahead-cliente [(ngModel)]="entity.cliente" name="cliente_{{i}}" id="cliente_{{i}}"
                                #cliente="ngModel" [ngControl]="cliente" #typeaheadCliente 
                                [idsIgnore]="getIdsClientesToIgnore()"
                                required="required" [disabled]="!canEdit" [readonly]="!canEdit"
                                [dropup]="i >= 4" (typeaheadChange)="onChangeCliente(entity, $event)">
                            </sgt-typeahead-cliente>
                            <sgt-form-control-error
                                *ngIf="cliente.errors && cliente.errors.required && cliente.dirty"
                                msgError="O cliente é obrigatório">
                            </sgt-form-control-error>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="entities?.length === 0" class="no-record">
                    <tr>
                        <td class="text-center" colspan="2">
                            <i class='fas fa-info' aria-hidden='true'></i> Nenhum cliente cadastrado
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-footer" *ngIf="canEdit">
            <button type="button" class="btn btn-primary btn-sm mr-2" (click)="insert()">
                <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Cliente
            </button>
        </div>
    </div>
</form>
